import ApiUrls from "services/ApiUrl";
import BaseService from "services/Base";
import { Master } from "types/common/master";

export default class InformationTypeService extends BaseService {

    async geAllInformationType(param: Master.BodyParamType = {}) {
      try {
        const response = await this.post(`${ApiUrls.informationType}/list`, param);
        return response?.data;
      } catch (error) {
        throw error;
      }
    }
}